import { render, staticRenderFns } from "./umur.vue?vue&type=template&id=5c1d2089"
import script from "./umur.vue?vue&type=script&lang=js"
export * from "./umur.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports